import { render } from "./inputPhoneNumber.vue?vue&type=template&id=8389b564"
import script from "./inputPhoneNumber.vue?vue&type=script&lang=js"
export * from "./inputPhoneNumber.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__